import { forwardRef } from 'react';
import UnderlineSelect from './Underline';
import OutlineSelect from './Outline';
import useScheduleUpdate from './useScheduleUpdate';

const Select = forwardRef(function Select(
  { variant = 'outline', ...props },
  ref
) {
  // This is for inline/overlays: see more info in implementation
  useScheduleUpdate(props);
  const VariantSelect =
    variant === 'underline' ? UnderlineSelect : OutlineSelect;
  return <VariantSelect ref={ref} {...props} />;
});

export default Select;

export const SelectNoScrollCapture = forwardRef((props, ref) => {
  return <Select ref={ref} captureMenuScroll={false} {...props} />;
});
